// import React, {
//   forwardRef,
//   useEffect,
//   useImperativeHandle,
//   useState,
// } from "react";
// import {
//   Calendar,
//   ChevronLeft,
//   Filter,
//   Building,
//   List,
//   MapPin,
//   LayoutList,
//   Building2,
// } from "lucide-react";
// import Select from "react-select";
// import "./AdvancedFilter.css";
// import { dateFormatConverter, formatDate } from "../../util/utilityFunctions";
// import { useSelector } from "react-redux";
// import { viewAllBranchesAPICall } from "../../API/Settings/Company Settings/companySettingsAPI";

// // Get current date and date 30 days ago
// const currentDate = new Date();
// const thirtyDaysAgo = new Date();
// thirtyDaysAgo.setDate(currentDate.getDate() - 180);

// const AdvancedFilter = forwardRef(
//   (
//     {
//       filterOptions = ["date", "branch", "status", "location", "category"],
//       handleFilter,
//       categoryOptions,
//     },
//     ref
//   ) => {
//     // --
//     const allBranchesList = useSelector(
//       (state) => state.allBranchesSlice.value
//     );
//     // console.log("all branch",allBranchesList)
//     // --
//     const [isOpen, setIsOpen] = useState(false);
//     const [activeFilter, setActiveFilter] = useState(null);
//     const [filterData, setFilterData] = useState({
//       date: { from: formatDate(thirtyDaysAgo), to: formatDate(currentDate) },
//       branch: [],
//       status: [],
//       location: [],
//       category: [],
//     });

//     // const [formData, setFormData] = useState({
//     //   branchOptions: [],
//     //   statusOptions: [],
//     // });

//     //  setFormData()

//     // const branchOptions = [
//     //   { value: "main", label: "Main Branch" },
//     //   { value: "downtown", label: "Downtown" },
//     //   { value: "suburb", label: "Suburb" },
//     //   { value: "airport", label: "Airport" },
//     //   { value: "central", label: "Central" },
//     //   { value: "east", label: "East Wing" },
//     //   { value: "west", label: "West Wing" },
//     // ];

//     const statusOptions = [
//       { value: "pending", label: "Pending" },
//       { value: "completed", label: "Completed" },
//       // { value: "in_progress", label: "In Progress" },
//       // { value: "cancelled", label: "Cancelled" },
//     ];
//     const locationOptions = [
//       { value: "l1", label: "l1" },
//       { value: "12", label: "l2" },
//       { value: "l3", label: "l3" },
//       { value: "l4", label: "l4" },
//     ];
//     // const categoryOptions = [
//     //   { value: "category1", label: "Category 1" },
//     //   { value: "category2", label: "Category 2" },
//     // ];

//     const handleApplyFilters = () => {
//       // console.log("Applied Filters:", filterData);
//       setIsOpen(false);
//       handleFilter(filterData);
//     };

//     const handleClearFilters = () => {
//       setFilterData({
//         date: { from: null, to: null },
//         branch: [],
//         status: [],
//         location: [],
//         category: [],
//         employee: [],
//         designation: [],
//         department: [],
//       });
//     };

//     // Expose the state to the parent using `useImperativeHandle`
//     useImperativeHandle(ref, () => ({
//       getChildState: () => filterData,
//       setFilterData,
//     }));

//     const renderFilterPreview = (filterName) => {
//       switch (filterName) {
//         case "date":
//           return filterData.date.from && filterData.date.to
//             ? `${dateFormatConverter(
//                 filterData.date.from
//               )} - ${dateFormatConverter(filterData.date.to)}`
//             : "No date selected";
//         case "branch":
//           return filterData.branch.length
//             ? `${filterData.branch.length} selected`
//             : "No branches selected";
//         case "status":
//           return filterData.status.length
//             ? `${filterData.status.length} selected`
//             : "No statuses selected";
//         case "location":
//           return filterData.location.length
//             ? `${filterData.location.length} selected`
//             : "No location selected";
//         case "category":
//           return filterData.category.length
//             ? `${filterData.category.length} selected`
//             : "No category selected";
//         case "employee":
//           return filterData.category.length
//             ? `${filterData.category.length} selected`
//             : "No employee selected";
//         case "designation":
//           return filterData.category.length
//             ? `${filterData.category.length} selected`
//             : "No designation selected";
//         case "department":
//           return filterData.category.length
//             ? `${filterData.category.length} selected`
//             : "No department selected";
//         default:
//           return "";
//       }
//     };

//     const filterByCondition = (option) => {
//       if (filterData.branch.length === 0) {
//         return option !== "location";
//       }
//       return true;
//     };

//     //--
//     const branchOptions = allBranchesList?.map((branch) => ({
//       value: branch._id,
//       label: branch.branchName,
//     }));

//     //initial api calls
//     useEffect(() => {
//       viewAllBranchesAPICall();
//     }, []);

//     const renderFilterContent = () => {
//       switch (activeFilter) {
//         case "date":
//           return (
//             <div className="adv-flt-filter-content">
//               <h4 className="adv-flt-filter-title">Select Date Range</h4>
//               <div className="adv-flt-date-range">
//                 <input
//                   type="date"
//                   className="adv-flt-date-input"
//                   value={filterData.date.from || ""}
//                   onChange={(e) =>
//                     setFilterData({
//                       ...filterData,
//                       date: { ...filterData.date, from: e.target.value },
//                     })
//                   }
//                 />
//                 <span>to</span>
//                 <input
//                   type="date"
//                   className="adv-flt-date-input"
//                   value={filterData.date.to || ""}
//                   onChange={(e) =>
//                     setFilterData({
//                       ...filterData,
//                       date: { ...filterData.date, to: e.target.value },
//                     })
//                   }
//                 />
//               </div>
//             </div>
//           );
//         case "branch":
//           return (
//             <div className="adv-flt-filter-content">
//               <h4 className="adv-flt-filter-title">Select Branches</h4>
//               <Select
//                 isMulti
//                 options={branchOptions}
//                 value={filterData.branch}
//                 onChange={(selected) =>
//                   setFilterData({
//                     ...filterData,
//                     branch: selected,
//                     location: selected.length === 0 ? [] : filterData.location,
//                   })
//                 }
//                 placeholder="Select branches"
//                 className="adv-flt-react-select"
//                 classNamePrefix="adv-flt-react-select"
//               />
//             </div>
//           );
//         case "status":
//           return (
//             <div className="adv-flt-filter-content">
//               <h4 className="adv-flt-filter-title">Select Statuses</h4>
//               <Select
//                 isMulti
//                 options={statusOptions}
//                 value={filterData.status}
//                 onChange={(selected) =>
//                   setFilterData({ ...filterData, status: selected })
//                 }
//                 placeholder="Select statuses"
//                 className="adv-flt-react-select"
//                 classNamePrefix="adv-flt-react-select"
//               />
//             </div>
//           );
//         case "location":
//           return (
//             <div className="adv-flt-filter-content">
//               <h4 className="adv-flt-filter-title">Select Location</h4>
//               <Select
//                 isMulti
//                 options={locationOptions}
//                 value={filterData.location}
//                 onChange={(selected) =>
//                   setFilterData({ ...filterData, location: selected })
//                 }
//                 placeholder="Select locations"
//                 className="adv-flt-react-select"
//                 classNamePrefix="adv-flt-react-select"
//               />
//             </div>
//           );
//         case "category":
//           return (
//             <div className="adv-flt-filter-content">
//               <h4 className="adv-flt-filter-title">Select category</h4>
//               <Select
//                 isMulti
//                 options={categoryOptions}
//                 value={filterData.category}
//                 onChange={(selected) =>
//                   setFilterData({ ...filterData, category: selected })
//                 }
//                 placeholder="Select categories"
//                 className="adv-flt-react-select"
//                 classNamePrefix="adv-flt-react-select"
//               />
//             </div>
//           );
//           case "employee":
//             return (
//               <div className="adv-flt-filter-content">
//                 <h4 className="adv-flt-filter-title">Select employee</h4>
//                 <Select
//                   isMulti
//                   options={categoryOptions}
//                   value={filterData.category}
//                   onChange={(selected) =>
//                     setFilterData({ ...filterData, category: selected })
//                   }
//                   placeholder="Select categories"
//                   className="adv-flt-react-select"
//                   classNamePrefix="adv-flt-react-select"
//                 />
//               </div>
//             );
//             case "designation":
//             return (
//               <div className="adv-flt-filter-content">
//                 <h4 className="adv-flt-filter-title">Select designation</h4>
//                 <Select
//                   isMulti
//                   options={categoryOptions}
//                   value={filterData.category}
//                   onChange={(selected) =>
//                     setFilterData({ ...filterData, category: selected })
//                   }
//                   placeholder="Select categories"
//                   className="adv-flt-react-select"
//                   classNamePrefix="adv-flt-react-select"
//                 />
//               </div>
//             );
//             case "department":
//             return (
//               <div className="adv-flt-filter-content">
//                 <h4 className="adv-flt-filter-title">Select department</h4>
//                 <Select
//                   isMulti
//                   options={categoryOptions}
//                   value={filterData.category}
//                   onChange={(selected) =>
//                     setFilterData({ ...filterData, category: selected })
//                   }
//                   placeholder="Select categories"
//                   className="adv-flt-react-select"
//                   classNamePrefix="adv-flt-react-select"
//                 />
//               </div>
//             );

//         default:
//           return (
//             <div className="adv-flt-filter-list">
//               {filterOptions.filter(filterByCondition).map((option) => (
//                 <div
//                   key={option}
//                   className="adv-flt-filter-option"
//                   onClick={() => setActiveFilter(option)}
//                 >
//                   {option === "date" && <Calendar className="adv-flt-icon" />}
//                   {option === "branch" && (
//                     <Building2 className="adv-flt-icon" />
//                   )}
//                   {option === "status" && <List className="adv-flt-icon" />}
//                   {option === "location" && <MapPin className="adv-flt-icon" />}
//                   {option === "category" && (
//                     <LayoutList className="adv-flt-icon" />
//                   )}
//                   <span>
//                     {option.charAt(0).toUpperCase() + option.slice(1)}
//                   </span>
//                   <span className="adv-flt-preview">
//                     {renderFilterPreview(option)}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           );
//       }
//     };

//     return (
//       <div className="adv-flt-container">
//         <button className="adv-flt-trigger" onClick={() => setIsOpen(!isOpen)}>
//           <Filter className="adv-flt-icon" />
//         </button>
//         {isOpen && (
//           <div className="adv-flt-popover">
//             {activeFilter && (
//               <button
//                 className="adv-flt-back-button"
//                 onClick={() => setActiveFilter(null)}
//               >
//                 <ChevronLeft className="adv-flt-icon" /> Back
//               </button>
//             )}
//             {renderFilterContent()}
//             <div className="adv-flt-actions">
//               <button
//                 className="adv-flt-button adv-flt-button-clear"
//                 onClick={handleClearFilters}
//               >
//                 Clear
//               </button>
//               <button
//                 className="adv-flt-button adv-flt-button-apply"
//                 onClick={handleApplyFilters}
//               >
//                 Apply
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }
// );

// export default AdvancedFilter;

// =============filter - v-2.0.0== G===============================
// import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
// import { Calendar, ChevronLeft, Filter, Building2, List, MapPin, LayoutList } from "lucide-react";
// import Select from "react-select";
// import "./AdvancedFilter.css";
// import { dateFormatConverter, formatDate } from "../../util/utilityFunctions";
// import { useSelector } from "react-redux";
// import { viewAllBranchesAPICall } from "../../API/Settings/Company Settings/companySettingsAPI";

// const currentDate = new Date();
// const thirtyDaysAgo = new Date();
// thirtyDaysAgo.setDate(currentDate.getDate() - 180);

// const FilterSelect = ({ title, options, value, onChange, placeholder }) => (
//   <div className="adv-flt-filter-content">
//     <h4 className="adv-flt-filter-title">{title}</h4>
//     <Select
//       isMulti
//       options={options}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       className="adv-flt-react-select"
//       classNamePrefix="adv-flt-react-select"
//     />
//   </div>
// );

// const AdvancedFilter = forwardRef(
//   (
//     { filterOptions = [], handleFilter, categoryOptions },
//     ref
//   ) => {
//     const allBranchesList = useSelector((state) => state.allBranchesSlice.value);
//     const [isOpen, setIsOpen] = useState(false);
//     const [activeFilter, setActiveFilter] = useState(null);
//     const [filterData, setFilterData] = useState({
//       date: { from: formatDate(thirtyDaysAgo), to: formatDate(currentDate) },
//       branch: [],
//       status: [],
//       location: [],
//       category: [],
//     });

//     const availableFilters = ["date", "branch", "status", "location", "category"];
//     const appliedFilters = filterOptions.length ? filterOptions : availableFilters;

//     const statusOptions = [
//       { value: "pending", label: "Pending" },
//       { value: "completed", label: "Completed" },
//     ];

//     const locationOptions = [
//       { value: "l1", label: "l1" },
//       { value: "l2", label: "l2" },
//       { value: "l3", label: "l3" },
//       { value: "l4", label: "l4" },
//     ];

//     const branchOptions = allBranchesList?.map((branch) => ({
//       value: branch._id,
//       label: branch.branchName,
//     }));

//     useEffect(() => {
//       viewAllBranchesAPICall();
//     }, []);

//     useImperativeHandle(ref, () => ({
//       getChildState: () => filterData,
//       setFilterData,
//     }));

//     const renderFilterPreview = (filterName) => {
//       const filterValue = filterData[filterName];
//       if (Array.isArray(filterValue)) {
//         return filterValue.length ? `${filterValue.length} selected` : `No ${filterName} selected`;
//       } else if (filterValue && filterValue.from && filterValue.to) {
//         return `${dateFormatConverter(filterValue.from)} - ${dateFormatConverter(filterValue.to)}`;
//       }
//       return `No ${filterName} selected`;
//     };

//     const filterContentMap = {
//       date: (
//         <FilterSelect
//           title="Select Date Range"
//           options={[]}
//           value={filterData.date}
//           onChange={(e) => setFilterData({ ...filterData, date: e.target.value })}
//           placeholder="Select date range"
//         />
//       ),
//       branch: (
//         <FilterSelect
//           title="Select Branches"
//           options={branchOptions}
//           value={filterData.branch}
//           onChange={(selected) => setFilterData({ ...filterData, branch: selected })}
//           placeholder="Select branches"
//         />
//       ),
//       status: (
//         <FilterSelect
//           title="Select Statuses"
//           options={statusOptions}
//           value={filterData.status}
//           onChange={(selected) => setFilterData({ ...filterData, status: selected })}
//           placeholder="Select statuses"
//         />
//       ),
//       location: (
//         <FilterSelect
//           title="Select Location"
//           options={locationOptions}
//           value={filterData.location}
//           onChange={(selected) => setFilterData({ ...filterData, location: selected })}
//           placeholder="Select locations"
//         />
//       ),
//       category: (
//         <FilterSelect
//           title="Select Category"
//           options={categoryOptions}
//           value={filterData.category}
//           onChange={(selected) => setFilterData({ ...filterData, category: selected })}
//           placeholder="Select categories"
//         />
//       ),
//     };

//     return (
//       <div className="adv-flt-container">
//         <button className="adv-flt-trigger" onClick={() => setIsOpen(!isOpen)}>
//           <Filter className="adv-flt-icon" />
//         </button>
//         {isOpen && (
//           <div className="adv-flt-popover">
//             {activeFilter && (
//               <button className="adv-flt-back-button" onClick={() => setActiveFilter(null)}>
//                 <ChevronLeft className="adv-flt-icon" /> Back
//               </button>
//             )}
//             {activeFilter ? (
//               filterContentMap[activeFilter]
//             ) : (
//               <div className="adv-flt-filter-list">
//                 {appliedFilters.map((option) => (
//                   <div key={option} className="adv-flt-filter-option" onClick={() => setActiveFilter(option)}>
//                     <span>{option.charAt(0).toUpperCase() + option.slice(1)}</span>
//                     <span className="adv-flt-preview">{renderFilterPreview(option)}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   }
// );

// export default AdvancedFilter;


import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  Calendar,
  ChevronLeft,
  Filter,
  Building2,
  List,
  MapPin,
  LayoutList,
  Users,
  IdCard,
  Building,
  CreditCard,
  FileText,
} from "lucide-react";
import Select from "react-select";
import "./AdvancedFilter.css";
import { dateFormatConverter, formatDate, getCurrentDate } from "../../util/utilityFunctions";
import { useSelector } from "react-redux";
import { viewAllBranchesAPICall } from "../../API/Settings/Company Settings/companySettingsAPI";
// import {
//   getAllDepartmentsAPI,
//   getAllDesignationsAPI,
//   listAllEmployees,
//   listJournalCategory,
// } from "../Modules/Payroll/parollAPIs";
import { getAllDepartmentsAPI, getAllDesignationsAPI, listAllEmployees, listJournalCategory } from "../Modules/Payroll/parollAPIs";
 
// Constants
const STORAGE_KEY = "advancedFilterState";
const INITIAL_DATE_RANGE = {
  from: getCurrentDate(-60),
  to: getCurrentDate(60),
};

const FILTER_ICONS = {
  date: Calendar,
  branch: Building2,
  status: List,
  location: MapPin,
  category: LayoutList,
  employee: Users,
  designation: IdCard,
  department: Building,
  payment:CreditCard,
  paymentType:FileText 
};

const INITIAL_FILTER_STATE = {
  date: INITIAL_DATE_RANGE,
  branch: [],
  status: [],
  location: [],
  category: [],
  employee: [],
  designation: [],
  department: [],
  payment:[],
  paymentType:[]
};

const STATUS_OPTIONS = [
  { value: "pending", label: "PENDING" },
  { value: "completed", label: "COMPLETED" },
  { value: "draft", label: "DRAFT" },
  { value: "drafted", label: "DRAFTED" },
  { value: "posted", label: "POSTED" },
  { value: "computed", label: "COMPUTED" },
  { value: "done", label: "DONE" },

];

const LOCATION_OPTIONS = [
  { value: "l1", label: "l1" },
  { value: "12", label: "l2" },
  { value: "l3", label: "l3" },
  { value: "l4", label: "l4" },
];

const PAYMENT_TYPE = [
  { value: "CHEQUE", label: "CHEQUE" },
  { value: "MANUAL", label: "MANUAL" },

]

// Improved Storage Utility
const StorageUtil = {
  saveState: (key, state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(`${STORAGE_KEY}_${key}`, serializedState);
    } catch (err) {
      console.error("Error saving filter state:", err);
    }
  },

  loadState: (key) => {
    try {
      const serializedState = localStorage.getItem(`${STORAGE_KEY}_${key}`);
      if (!serializedState) return null;

      const parsedState = JSON.parse(serializedState);
console.log("sas");

      // Restore date objects
      if (parsedState.date) {
        parsedState.date = {
          from: parsedState.date.from || INITIAL_DATE_RANGE.from,
          to: parsedState.date.to || INITIAL_DATE_RANGE.to,
        };
      }

      // Ensure all arrays are initialized
      Object.keys(INITIAL_FILTER_STATE).forEach((key) => {
        if (Array.isArray(INITIAL_FILTER_STATE[key])) {
          parsedState[key] = parsedState[key] || [];
        }
      });

      return parsedState;
    } catch (err) {
      console.error("Error loading filter state:", err);
      return null;
    }
  },

  clearState: (key) => {
    try {
      localStorage.removeItem(`${STORAGE_KEY}_${key}`);
    } catch (err) {
      console.error("Error clearing filter state:", err);
    }
  },
};

// Component definitions remain the same as before...
const FilterOption = ({ option, preview, onSelect }) => {
  const Icon = FILTER_ICONS[option];
  return (
    <div className="adv-flt-filter-option" onClick={onSelect}>
      {Icon && <Icon className="adv-flt-icon" />}
      <span>{option.charAt(0).toUpperCase() + option.slice(1)}</span>
      <span className="adv-flt-preview">{preview}</span>
    </div>
  );
};

const DateRangeFilter = ({ value, onChange }) => (
  <div className="adv-flt-filter-content">
    <h4 className="adv-flt-filter-title">Select Date Range</h4>
    <div className="adv-flt-date-range">
      <input
        type="date"
        className="adv-flt-date-input"
        value={value.from || ""}
        onChange={(e) => onChange({ ...value, from: e.target.value })}
      />
      <span>to</span>
      <input
        type="date"
        className="adv-flt-date-input"
        value={value.to || ""}
        onChange={(e) => onChange({ ...value, to: e.target.value })}
      />
    </div>
  </div>
);

const MultiSelectFilter = ({
  title,
  options,
  value,
  onChange,
  placeholder,
}) => (
  <div className="adv-flt-filter-content">
    <h4 className="adv-flt-filter-title">{title}</h4>
    <Select
      isMulti
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="adv-flt-react-select"
      classNamePrefix="adv-flt-react-select"
    />
  </div>
);

const AdvancedFilter = forwardRef(
  (
    {
      filterOptions = ["date", "branch", "status", "location", "category"],
      handleFilter,
      categoryOptions,
      pageName = "default", // Default page name if not provided
    },
    ref
  ) => {
   
    // const { statusShowOptions } = useSelector((state) => state.filterSlice)
    const { statusShowOptions = [] } = useSelector((state) => state.filterSlice || {});


    const allBranchesList = useSelector(
      (state) => state.allBranchesSlice.value
    );
    const loginCred = JSON.parse(localStorage.getItem("login_meta"));

    const [isOpen, setIsOpen] = useState(false);
    const [activeFilter, setActiveFilter] = useState(null);
    const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
    const [initialized, setInitialized] = useState(false);
    const [statusOptions, setStatusOptions] = useState()

    //update status based on status show option 
    // useEffect(() => {
    //   if (statusShowOptions) {
    //     const filteredList = STATUS_OPTIONS.filter((option) =>
    //       statusShowOptions.includes(option.label) // Match labels instead of values
    //     );
    //     // console.log("Filtered Status Options: ", filteredList);
    //     setStatusOptions(filteredList);
    //   }
    // }, [statusShowOptions]);

useEffect(() => {
  if (statusShowOptions) {
    const filteredList = STATUS_OPTIONS.filter((option) =>
      statusShowOptions.includes(option.label)
    );
    
    // ✅ Only update if filteredList is different
    const isSame =
      statusOptions?.length === filteredList.length &&
      statusOptions.every((opt, i) => opt.value === filteredList[i].value);

    if (!isSame) {
      setStatusOptions(filteredList);
    }
  }
}, [statusShowOptions]);

    //
    const [listData, setListData] = useState({
      employeeList: [],
      departmentList: [],
      designationList: [],
      journalList:[]
    });

    const branchOptions = allBranchesList?.map((branch) => ({
      value: branch._id,
      label: branch.branchName,
    }));
    // Initialize data and load saved state
    useEffect(() => {
      const loadSavedState = async () => {
        // get all branch
        viewAllBranchesAPICall();

        const apis = [
          {
            call: (cb) =>
              listAllEmployees({ branchId: loginCred?.branchPk, ...cb }),
            key: "employeeList",
            mapFn: (r) => ({ value: r._id, label: r.staff_name }),
          },
          {
            call: getAllDesignationsAPI,
            key: "designationList",
            mapFn: (r) => ({ value: r._id, label: r.departmentName }),
          },
          {
            call: getAllDepartmentsAPI,
            key: "departmentList",
            mapFn: (r) => ({ value: r._id, label: r.departmentName }),
          },
          {
            call: listJournalCategory,
            key: "journalList",
            mapFn: (r) => ({ value: r._id, label: r.journalName }),
          },
        ];

        apis.forEach(({ call, key, mapFn }) =>
          call({
            successCallback: (data = []) =>{
              setListData((prev) => ({
                ...prev,
                [key]: data.length ? data.map(mapFn) : [],
              }))},
            errorCallback: () =>
              setListData((prev) => ({ ...prev, [key]: [] })),
          })
        );

        const savedState = StorageUtil.loadState(pageName);

        if (savedState) {
          // Restore saved state with proper object references
          const restoredState = {
            ...INITIAL_FILTER_STATE,
            ...savedState,
            // Restore select values with proper option objects
            branch:
              savedState.branch?.map((item) => ({
                value: item.value,
                label: item.label,
              })) || [],
            status:
              savedState.status?.map(
                (item) =>
                  STATUS_OPTIONS.find((opt) => opt.value === item.value) || item
              ) || [],
            location:
              savedState.location?.map(
                (item) =>
                  LOCATION_OPTIONS.find((opt) => opt.value === item.value) ||
                  item
              ) || [],
            category:
              savedState.category?.map((item) => ({
                value: item.value,
                label: item.label,
              })) || [],
            employee:
              savedState.employee?.map((item) => ({
                value: item.value,
                label: item.label,
              })) || [],
            designation:
              savedState.designation?.map((item) => ({
                value: item.value,
                label: item.label,
              })) || [],
            department:
              savedState.department?.map((item) => ({
                value: item.value,
                label: item.label,
              })) || [],
              payment:
              savedState.payment?.map((item) => ({
                value: item.value,
                label: item.label,
              })) || [],
              paymentType:
              savedState.location?.map(
                (item) =>
                  PAYMENT_TYPE.find((opt) => opt.value === item.value) ||
                  item
              ) || [],
          };

          setFilterData(restoredState);
          handleFilter(restoredState);
        }
        setInitialized(true);
      };

      loadSavedState();
    }, [pageName]);

    // Save state when filterData changes
    useEffect(() => {
      if (initialized) {
        StorageUtil.saveState(pageName, filterData);
      }
    }, [filterData, pageName, initialized]);

    useImperativeHandle(ref, () => ({
      getChildState: () => filterData,
      setFilterData: (newData) => {
        setFilterData(newData);
        StorageUtil.saveState(pageName, newData);
      },
      clearStorage: () => StorageUtil.clearState(pageName),
    }));

    const handleFilterChange = (key, value) => {
      const newFilterData = {
        ...filterData,
        [key]: value,
        ...(key === "branch" && value.length === 0 ? { location: [] } : {}),
      };
      setFilterData(newFilterData);
    };

    const handleClearFilters = () => {
      const newState = INITIAL_FILTER_STATE;
      setFilterData(newState);
      StorageUtil.clearState(pageName);
      handleFilter(newState);
    };

    const getFilterPreview = (filterName) => {
      const data = filterData[filterName];
      if (filterName === "date") {
        return data.from && data.to
          ? `${dateFormatConverter(data.from)} - ${dateFormatConverter(
            data.to
          )}`
          : "No date selected";
      }
      return data.length
        ? `${data.length} selected`
        : `No ${filterName} selected`;
    };

    const renderFilterContent = () => {
      if (!activeFilter) {
        return (
          <div className="adv-flt-filter-list">
            {filterOptions
              .filter((option) =>
                filterData.branch.length === 0 ? option !== "location" : true
              )
              .map((option) => (
                <FilterOption
                  key={option}
                  option={option}
                  preview={getFilterPreview(option)}
                  onSelect={() => setActiveFilter(option)}
                />
              ))}
          </div>
        );
      }

      const filterComponents = {
        date: () => (
          <DateRangeFilter
            value={filterData.date}
            onChange={(value) => handleFilterChange("date", value)}
          />
        ),
        branch: () => (
          <MultiSelectFilter
            title="Select Branches"
            options={branchOptions}
            value={filterData.branch}
            onChange={(selected) => handleFilterChange("branch", selected)}
            placeholder="Select branches"
          />
        ),
        status: () => (
          <MultiSelectFilter
            title="Select Statuses"
            options={statusOptions}
            value={filterData.status}
            onChange={(selected) => handleFilterChange("status", selected)}
            placeholder="Select statuses"
          />
        ),
        location: () => (
          <MultiSelectFilter
            title="Select Location"
            options={LOCATION_OPTIONS}
            value={filterData.location}
            onChange={(selected) => handleFilterChange("location", selected)}
            placeholder="Select locations"
          />
        ),
        category: () => (
          <MultiSelectFilter
            title="Select Category"
            options={categoryOptions}
            value={filterData.category}
            onChange={(selected) => handleFilterChange("category", selected)}
            placeholder="Select categories"
          />
        ),
        employee: () => (
          <MultiSelectFilter
            title="Select employee"
            options={listData?.employeeList}
            value={filterData.employee}
            onChange={(selected) => handleFilterChange("employee", selected)}
            placeholder="Select employees"
          />
        ),
        designation: () => (
          <MultiSelectFilter
            title="Select designation"
            options={listData?.designationList}
            value={filterData.designation}
            onChange={(selected) => handleFilterChange("designation", selected)}
            placeholder="Select designations"
          />
        ),
        department: () => (
          <MultiSelectFilter
            title="Select department"
            options={listData?.departmentList}
            value={filterData.department}
            onChange={(selected) => handleFilterChange("department", selected)}
            placeholder="Select departments"
          />
        ),
        payment: () => (
          <MultiSelectFilter
            title="Select payment method"
            options={listData?.journalList}
            value={filterData.payment}
            onChange={(selected) => handleFilterChange("payment", selected)}
            placeholder="Select payment Method"
          />
        ),
        paymentType: () => (
          <MultiSelectFilter
            title="Select payment Type"
            options={PAYMENT_TYPE}
            value={filterData.paymentType}
            onChange={(selected) => handleFilterChange("paymentType", selected)}
            placeholder="Select payment type"
          />
        ),
      };

      return filterComponents[activeFilter]?.() || null;
    };
    const selectedFiltersCount = getSelectedFiltersCount(filterData);
    return (
      <div className="adv-flt-container">
        <button className="adv-flt-trigger" onClick={() => setIsOpen(!isOpen)}>
          <Filter className="adv-flt-icon" />
          {selectedFiltersCount > 0 && (
            <span className="adv-flt-badge">{selectedFiltersCount}</span>
          )}
        </button>
        {isOpen && (
          <div className="adv-flt-popover">
            {activeFilter && (
              <button
                className="adv-flt-back-button"
                onClick={() => setActiveFilter(null)}
              >
                <ChevronLeft className="adv-flt-icon" /> Back
              </button>
            )}
            {renderFilterContent()}
            <div className="adv-flt-actions">
              <button
                className="adv-flt-button adv-flt-button-clear"
                onClick={handleClearFilters}
              >
                Clear
              </button>
              <button
                className="adv-flt-button adv-flt-button-apply"
                onClick={() => {
                  handleFilter(filterData);
                  setIsOpen(false);
                }}
              >
                Apply
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default AdvancedFilter;


const getSelectedFiltersCount = (filterData) => {
  let count = 0;
  
  // Count date range if either from or to is different from initial
  if (
    filterData.date.from !== INITIAL_DATE_RANGE.from ||
    filterData.date.to !== INITIAL_DATE_RANGE.to
  ) {
    count++;
  }

  // Count all array-based filters
  Object.keys(filterData).forEach((key) => {
    if (Array.isArray(filterData[key]) && filterData[key].length > 0) {
      count++;
    }
  });

  return count;
};